import { useState } from 'react';
import { Form, Input, Modal } from 'antd';
import { ApiError } from '@mall/shared';
import { useToast } from '../../app/ToastProvider';
import { changePassword } from './api';

type FormValues = {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export function ChangePasswordModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const toast = useToast();
  const [form] = Form.useForm<FormValues>();
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  const handleOk = async () => {
    try {
      const v = await form.validateFields();
      if (v.newPassword !== v.confirmPassword) {
        form.setFields([
          { name: 'confirmPassword', errors: ['两次输入的新密码不一致'] },
        ]);
        return;
      }
      setLoading(true);
      await changePassword({
        currentPassword: v.currentPassword,
        newPassword: v.newPassword,
      });
      toast.success('密码已更新');
      form.resetFields();
      onClose();
    } catch (err) {
      if (err && typeof err === 'object' && 'errorFields' in err) {
        return;
      }
      const message = err instanceof ApiError ? err.message : '修改失败';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="修改密码"
      open={open}
      onCancel={handleCancel}
      onOk={() => void handleOk()}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form form={form} layout="vertical" preserve={false} autoComplete="off">
        <Form.Item
          name="currentPassword"
          label="当前密码"
          rules={[{ required: true, message: '请输入当前密码' }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label="新密码"
          rules={[
            { required: true, message: '请输入新密码' },
            { min: 8, message: '至少 8 个字符' },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          label="确认新密码"
          rules={[{ required: true, message: '请再次输入新密码' }]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
}
